/**
 * @param {json} details
 * @return {string} url encoded format from a json object
 */
const encodeFormUrl = details =>
  Object.entries(details)
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(value)}`,
    )
    .join('&');

export default encodeFormUrl;
